'use client';

import { useEffect, useState } from 'react';
import { BookDetail_Component } from '../components/bookDetail/book-detail';

export default function Page() {
  const [bookId, setBookId] = useState(null);

  useEffect(() => {
    // Check if there's a book ID in query params
    const searchParams = new URLSearchParams(window.location.search);
    const id = searchParams.get("id");
    
    if (id) {
      setBookId(id);
    }
  }, []);

  // If a book ID is provided, show the book detail page
  if (bookId) {
    return <BookDetail_Component bookId={bookId} />;
  }

  // Default homepage
  return (
    <main className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <div className="flex items-center justify-center min-h-screen px-4">
        <div className="text-center space-y-6">
          <h1 className="text-5xl font-bold text-white">Welcome to Our Bookstore</h1>
          <p className="text-xl text-slate-300 max-w-2xl">
            Discover amazing books and read reviews from our community
          </p>
          <div className="pt-8">
            <input
              type="text"
              placeholder="Enter book ID to view details..."
              onKeyPress={(e) => {
                if (e.key === 'Enter' && e.currentTarget.value) {
                  window.location.href = `?id=${e.currentTarget.value}`;
                }
              }}
              className="px-6 py-3 rounded-lg bg-slate-800/50 text-white placeholder-slate-400 border border-slate-700 focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-500/20 transition-all duration-300"
            />
          </div>
        </div>
      </div>
    </main>
  );
}
